import { Box, TextField, Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { AzulIconButton } from '@the-ksquare-group/azul-ds';
import React, { Fragment, useState } from 'react';
import Button from 'components/Button/Button';
import { colorPalette, docGeniusPalette } from 'styles/partials/colors';
import { ModalProps } from '../ModalFactory';
import { usePatchDocumentMutation, usePatchDocumentVersionMutation } from 'features/document/documentApi';
import { usePatchDocumentTemplateVersionMutation, usePatchTemplateMutation } from 'features/template/templateApi';

interface RenameTypeProps extends ModalProps {
  type: 'document' | 'version';
}

const documentLabels = {
  title: 'Rename Document',
  subTitle: 'Enter a new name for the document',
  placeHolder: 'New document name',
  button: 'Rename Document',
};

const versionLabels = {
  title: 'Name this version',
  subTitle: 'Enter a name for this document version',
  placeHolder: 'Version Name',
  button: 'Name Version',
};

export default function RenameModalContent({ modalData, onClose, type }: RenameTypeProps) {
  const [renameHandler, setRenameHandler] = useState('');
  const [patchDocument] = usePatchDocumentMutation();
  const [patchTemplate] = usePatchTemplateMutation();
  const [patchDocumentVersion] = usePatchDocumentVersionMutation();
  const [patchDocumentTemplateVersion] = usePatchDocumentTemplateVersionMutation();
  const isDocument = type === 'document';

  const handleRenameFile = async () => {
    const { id, isTemplate, isVersion } = modalData;
    if (isTemplate && !isVersion) {
      await patchTemplate({ id, name: renameHandler });
    }
    if (isVersion) {
      if (isTemplate) {
        await patchDocumentTemplateVersion({ id, name: renameHandler });
      } else {
        await patchDocumentVersion({ id, name: renameHandler });
      }
    } else {
      await patchDocument({ id, name: renameHandler });
    }
    onClose();
  };

  return (
    <Fragment>
      <Box sx={{ position: 'absolute', right: ' 20px', top: '29px' }}>
        <AzulIconButton
          icon={<CloseRoundedIcon sx={{ color: colorPalette.primaryBlue }} />}
          tooltipTitle='Close'
          onClick={onClose}
        />
      </Box>
      <Typography
        id='modal-modal-title'
        variant='h6'
        component='h2'
        fontSize='24px'
        sx={{ color: docGeniusPalette.neutralGray }}
      >
        {isDocument ? documentLabels.title : versionLabels.title}
      </Typography>
      <Typography id='modal-modal-description' sx={{ mt: 2 }}>
        {isDocument ? documentLabels.subTitle : versionLabels.subTitle}
      </Typography>
      <Box sx={{ marginTop: '10px' }} />
      <TextField
        fullWidth
        placeholder={isDocument ? documentLabels.placeHolder : versionLabels.placeHolder}
        name='Rename'
        value={renameHandler}
        onChange={e => setRenameHandler(e.target.value)}
      />
      <Box sx={{ marginTop: '80px' }} />
      <Box
        sx={{
          display: 'flex',
          position: 'absolute',
          bottom: '33px',
          right: '32px',
        }}
      >
        <Button variant='secondary' onClick={onClose}>
          Cancel
        </Button>
        <Box sx={{ marginRight: '20px' }} />
        <Button onClick={handleRenameFile}>{isDocument ? documentLabels.button : versionLabels.button}</Button>
      </Box>
    </Fragment>
  );
}

